@if (!useNewProfileDropdown()) {
  <atlas-item interactable ariaLabel="User menu">
    <span class="atlas-navbar__user-dropdown">
      @if (!impersonateeUsername) {
        <span class="atlas-navbar__user-content-wrapper">
          {{ username }}
          <i class="material-icons">arrow_drop_down</i>
        </span>
      }
      @if (!!impersonateeUsername) {
        <span class="atlas-navbar__user-content-wrapper">
          <div>
            <div class="atlas-navbar__user-content-wrapper-username">{{ username }} as</div>
            <div class="atlas-navbar__user-content-wrapper-impersonatee-username">
              {{ impersonateeUsername }}
            </div>
          </div>
          <i class="material-icons">arrow_drop_down</i>
        </span>
      }
    </span>
    <span class="atlas-navbar__user-dropdown--mobile">
      <span class="atlas-navbar__user-content-wrapper">
        @if (!impersonateeUsername) {
          <i class="material-icons">person</i>
        } @else {
          <i class="material-icons">people_alt</i>
        }
      </span>
    </span>
    <atlas-menu id="atlas-navbar__user-dropdown">
      <div class="atlas-navbar__menu">
        <div class="atlas-navbar__menu__static" (click)="intercept($event)">
          @if (!!email) {
            <div
              class="atlas-navbar__user-info"
              [ngClass]="{
                'atlas-navbar__user-info--impersonation': !!impersonateeUsername,
              }"
            >
              <div>
                {{ 'DROPDOWN_MENU.SIGNED_IN_AS' | translate }}
              </div>
              <div class="atlas-navbar__user-email">
                {{ email }}
              </div>
            </div>
          }
          @if (!!impersonateeUsername && !!email) {
            <div class="atlas-navbar__user-info__username">
              <div>
                {{ username }}
                {{ 'DROPDOWN_MENU.IMPERSONATING_USER_AS' | translate }}
              </div>
              <div class="atlas-navbar__user-info__impersonatee">
                {{ impersonateeUsername }}
              </div>
            </div>
          }
          @if (!!userSwitcherData) {
            <div class="atlas-navbar__menu-divider"></div>
            <div class="atlas-navbar__user-switcher">
              <div class="atlas-navbar__user-switcher-partner-name">{{ partnerName }}</div>
              <a (click)="openUserSwitcher()">{{ 'DROPDOWN_MENU.SWITCH_USER' | translate }}</a>
            </div>
          }
          @if (!!email) {
            <div class="atlas-navbar__menu-divider"></div>
          }
          @if (showLanguageSelector()) {
            <atlas-menu-item (click)="showSwitchLanguageDialog()">
              <span class="atlas-navbar__menu__language-selector__label">
                @let flag = $safeNavigationMigration((currentLanguage$ | async)?.flag);
                @if (!flag) {
                  <i class="material-icons">language</i>
                } @else {
                  <span class="atlas-navbar__menu__language-selector__flag">{{ flag }}</span>
                }
                {{ languageLabel$ | async }}
              </span>
            </atlas-menu-item>
          }
        </div>
        @for (menuItem of extraMenuItems() || []; track $index) {
          @if (!menuItem.callback && !menuItem.eventId) {
            <atlas-menu-item [label]="menuItem.label" [url]="menuItem.url" [route]="menuItem.route"></atlas-menu-item>
          } @else {
            <atlas-menu-item [label]="menuItem.label" (click)="itemClick(menuItem)"></atlas-menu-item>
          }
        }
        @for (menuItem of menuItems(); track $index) {
          <atlas-menu-item [label]="menuItem.text" [url]="menuItem.url"></atlas-menu-item>
        }
        @if (!!signOutUrl) {
          <atlas-menu-item [label]="'Sign out'" [url]="signOutUrl"></atlas-menu-item>
        }
      </div>
    </atlas-menu>
  </atlas-item>
}

@if (!!useNewProfileDropdown()) {
  <div cdkOverlayOrigin #trigger="cdkOverlayOrigin">
    <button mat-icon-button aria-label="User menu" (click)="open() === true ? open.set(false) : open.set(true)" cdkOverlayOrigin>
      <glxy-avatar matListItemAvatar [src]="avatarButtonUrl()" [name]="username" [width]="24" />
    </button>
  </div>
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="open()"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    [cdkConnectedOverlayPanelClass]="['atlas-navbar__user-dropdown']"
    (backdropClick)="open.set(false)"
  >
    <div class="useDropdownPortal mat-elevation-z8">
      <div>
        @if (!!email) {
          <div
            class="atlas-navbar__user-info"
            [ngClass]="{
              'atlas-navbar__user-info--impersonation': !!impersonateeUsername,
            }"
          >
            <div>
              {{ 'DROPDOWN_MENU.SIGNED_IN_AS' | translate }}
            </div>
            <div class="atlas-navbar__user-email">
              {{ email }}
            </div>
          </div>
        }
        @if (!!impersonateeUsername && !!email) {
          <div class="atlas-navbar__user-info__username">
            <div>
              {{ username }}
              {{ 'DROPDOWN_MENU.IMPERSONATING_USER_AS' | translate }}
            </div>
            <div class="atlas-navbar__user-info__impersonatee">
              {{ impersonateeUsername }}
            </div>
          </div>
        }
        @if (!!userSwitcherData) {
          <mat-divider></mat-divider>
          <div class="atlas-navbar__user-switcher">
            <div class="atlas-navbar__user-switcher-partner-name">{{ partnerName }}</div>
            <a (click)="openUserSwitcher()">{{ 'DROPDOWN_MENU.SWITCH_USER' | translate }}</a>
          </div>
        }
        <mat-divider></mat-divider>
        <mat-action-list>
          @if (showLanguageSelector()) {
            <mat-list-item class="list-item-with-icon" (click)="showSwitchLanguageDialog()">
              @let flag = $safeNavigationMigration((currentLanguage$ | async)?.flag);
              @if (!flag) {
                <mat-icon matListItemIcon>language</mat-icon>
              } @else {
                <img matListItemAvatar src="{{ flag }}" />
              }
              <p matListItemTitle>{{ languageLabel$ | async }}</p>
            </mat-list-item>
          }
          <atlas-theme-switcher></atlas-theme-switcher>
          @for (menuItem of extraMenuItems() || []; track $index) {
            @if (!menuItem.callback && !menuItem.eventId) {
              @if (menuItem.url) {
                <a mat-list-item [href]="menuItem.url">{{ menuItem.label | translate }}</a>
              } @else {
                <a mat-list-item [routerLink]="menuItem.route">{{ menuItem.label | translate }}</a>
              }
            } @else if (!!menuItem.callback || !!menuItem.eventId) {
              <button mat-list-item (click)="itemClick(menuItem)">{{ menuItem.label | translate }}</button>
            }
          }
          @for (menuItem of menuItems(); track $index) {
            <a mat-list-item [href]="menuItem.url">{{ menuItem.text }}</a>
          }
          @if (!!signOutUrl) {
            <a mat-list-item [href]="signOutUrl">Sign out</a>
          }
        </mat-action-list>
      </div>
    </div>
  </ng-template>
}
